import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { AvailabilityService } from '../../core/services/availability.service';
import { NotificationService } from '../../core/services/notification.service';
import { DAY_NAMES, DayOfWeek, DEFAULT_WEEKLY_SCHEDULE, WeeklySchedule } from '../../core/models/schedule.model';

type OnboardingStep = 'welcome' | 'services' | 'availability' | 'share';

interface ServiceEntry {
  label: string;
  duration: number;
  price: number;
  enabled: boolean;
}

@Component({
  selector: 'app-onboarding',
  standalone: false,
  templateUrl: './onboarding.component.html',
  styleUrl: './onboarding.component.scss',
})
export class OnboardingComponent implements OnInit {
  step: OnboardingStep = 'welcome';

  services: ServiceEntry[] = [
    { label: 'Consulta inicial 30 min',   duration: 30, price: 8000,  enabled: true  },
    { label: 'Consulta inicial 60 min',   duration: 60, price: 14000, enabled: true  },
    { label: 'Revisión de planos 30 min', duration: 30, price: 6000,  enabled: false },
    { label: 'Revisión de planos 60 min', duration: 60, price: 11000, enabled: false },
  ];

  schedule: WeeklySchedule = JSON.parse(JSON.stringify(DEFAULT_WEEKLY_SCHEDULE));
  dayNames = DAY_NAMES;
  timeOptions = this.buildTimeOptions();
  publicLink = '';
  readonly days: DayOfWeek[] = [0, 1, 2, 3, 4, 5, 6];

  constructor(
    private auth: AuthService,
    private availSvc: AvailabilityService,
    private notifSvc: NotificationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const user = this.auth.currentUserSnapshot;
    if (!user) { this.router.navigate(['/login']); return; }
    this.publicLink = `${window.location.origin}/book/${user.id}`;
  }

  get steps(): OnboardingStep[] {
    return ['welcome', 'services', 'availability', 'share'];
  }

  get stepIndex(): number {
    return this.steps.indexOf(this.step);
  }

  get profesionalName(): string {
    return this.auth.currentUserSnapshot?.name ?? 'profesional';
  }

  next(): void {
    const idx = this.stepIndex;
    if (idx < this.steps.length - 1) {
      this.step = this.steps[idx + 1];
    }
  }

  back(): void {
    const idx = this.stepIndex;
    if (idx > 0) {
      this.step = this.steps[idx - 1];
    }
  }

  saveAndFinish(): void {
    // Persist schedule
    this.availSvc.save(this.schedule);
    // Mark onboarding complete
    const user = this.auth.currentUserSnapshot;
    if (user) {
      localStorage.setItem(`onboarding_done_${user.id}`, '1');
    }
    this.notifSvc.success('¡Configuración completada! Tu perfil está listo.');
    this.router.navigate(['/professional']);
  }

  copyLink(): void {
    navigator.clipboard.writeText(this.publicLink).then(() => {
      this.notifSvc.success('¡Link copiado al portapapeles!');
    });
  }

  daySchedule(day: DayOfWeek) {
    return this.schedule[day];
  }

  private buildTimeOptions(): string[] {
    const times: string[] = [];
    for (let h = 7; h <= 21; h++) {
      times.push(`${String(h).padStart(2,'0')}:00`);
      times.push(`${String(h).padStart(2,'0')}:30`);
    }
    return times;
  }
}
